import { render, staticRenderFns } from "./Aspecto.vue?vue&type=template&id=71cd14ee"
import script from "./Aspecto.vue?vue&type=script&lang=js"
export * from "./Aspecto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports